import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useIssueDeveloperKeyMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.issueKey(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.keys() }), i.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { i as useIssueDeveloperKeyMutation };
